let inMemoryPermissions: string[] = [];

export const setInMemoryPermissions = (perms: string[]) => {
    inMemoryPermissions = perms;
};

export const HasPermission = (perm: string): boolean => {
  const permissions = inMemoryPermissions ?? [];
  return permissions.includes(perm);
};

